Object.defineProperty(exports, "__esModule", {
  value: true
});
var b = require("/app/node_modules/koa-rpc-call/browser");
var o = exports['default'] = {};
o["getResidenceUrl"] = b.createRpcProxy("ApplicationSettingsApi", "getResidenceUrl", {
  "urlPrefix": "/rpc"
});